// extracted by mini-css-extract-plugin
export default {"commentList":"commentList_commentList__GtS6R","commenter":"commentList_commenter__3Q-8w","comment":"commentList_comment__zHbSe"};